const module = { name: 'news/overview/app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { default as deferImages } from 'swug-fdRequire-call:global/jcarousel.deferImages';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as wall } from 'swug-fdRequire-call:news/overview/wall';



const Selectors = {
    CAST_CAROUSEL_ID: 'castCarousel',
    MOVIE_CAROUSEL_ID: 'hubMovieCarousel',
    FEATURED_VIDS_CAROUSEL_ID: 'featuredVideosCarousel',
    FRONT_RUNNERS_CAROUSEL_ID: 'frontRunnersVideosCarousel',
    VID_FLIPS: '.js-video-carousel-flippers-wrap',
}


const Styles = {
    FLIPS_VISIBLE: 'video-carousel__flippers--visible',
}
function onKeyup() {
    const carousel = this;
    if (carousel.usingKeyboard) {
        return;
    }
    carousel.usingKeyboard = true;
    $(Selectors.VID_FLIPS, carousel.carousel()).addClass(Styles.FLIPS_VISIBLE);
}
function showNav(carousel) {
    if (!carousel) {
        return;
    }
    carousel.usingKeyboard = false;
    carousel.list().on('keyup', onKeyup.bind(carousel));
}
function run() {
    checkDependencies(module.name, debugLog);
    deferImages.init();
    if (!isMobile) {
        fdCarousel.init('featured-carousel');
    }
    const opts = {
        autoWidth: true
    };
    fdCarousel.init(Selectors.CAST_CAROUSEL_ID, opts);
    fdCarousel.init(Selectors.MOVIE_CAROUSEL_ID, opts);
    let carousel;
    carousel = fdCarousel.init(Selectors.FEATURED_VIDS_CAROUSEL_ID, opts);
    showNav(carousel);
    carousel = fdCarousel.init(Selectors.FRONT_RUNNERS_CAROUSEL_ID, opts);
    showNav(carousel);
    wall.init();
}
run();
export default module.exports;